import React from 'react';
import { Card, Typography, Space } from 'antd';
import { useDarkMode } from 'src/context/DarkModeContext'; // assuming you have a dark mode context
import { ReflexiveModel } from 'src/data/models/ReflexiveVerbsModel';

const { Title, Text } = Typography;

const ReflexiveVerbCard: React.FC<{ verbData: ReflexiveModel }> = ({ verbData }) => {
    const { isDarkMode } = useDarkMode();

    return (
        <Card className={`example-card ${isDarkMode ? 'dark' : 'light'}`}>

            <Space
                className='example-card-sentence'
                direction="vertical" size="large" style={{ width: '100%' }}>
                {/* Verb Title */}
                <Title level={4} style={{ color: isDarkMode ? '#e6e6e6' : '#003a8c' }}>
                    {verbData.verb}
                </Title>

                {/* Non-Reflexive Section */}
                <div>
                    <Text style={{ color: isDarkMode ? '#7bbdfb' : '#6b99f8' }} strong>Non-Reflexive Meaning: </Text>
                    <Text style={{ color: isDarkMode ? '#e6e6e6' : 'black' }}>{verbData.nonReflexiveMeaning}</Text>
                    <br />
                    <Text style={{ color: isDarkMode ? '#eeeeee' : '#444444' }} italic>{verbData.nonReflexiveExample}</Text>
                </div>

                {/* Reflexive Section */}
                <div>
                    <Text style={{ color: isDarkMode ? '#7bbdfb' : '#6b99f8' }} strong>Reflexive Meaning: </Text>
                    <Text style={{ color: isDarkMode ? '#e6e6e6' : 'black' }}>{verbData.reflexiveMeaning}</Text>
                    <br />
                    <Text style={{ color: isDarkMode ? '#eeeeee' : '#444444' }} italic>{verbData.reflexiveExample}</Text>
                </div>
            </Space>
        </Card>
    );
};

export default ReflexiveVerbCard;